// Fiat amounts show 2 decimals; crypto amounts show 8 (a position of 0.00431257
// BTC or 12.50000000 USDT must not be rounded to 2 places). A currency is
// treated as crypto when it is not an ISO 4217 fiat code, which also covers
// tokens that are not on the platform's own currency list.
const FALLBACK_FIAT = [
  "USD", "EUR", "GBP", "NGN", "KES", "GHS", "ZAR", "EGP", "ETB", "GMD", "LRD", "MWK", "RWF", "SLE", "TZS",
  "UGX", "XAF", "XOF", "ZMW", "CAD", "AUD", "JPY", "CNY", "INR", "BRL", "MXN", "PHP", "IDR", "MAD", "BDT",
];

let fiatCodes;
const getFiatCodes = () => {
  if (fiatCodes) return fiatCodes;
  try {
    fiatCodes = new Set(Intl.supportedValuesOf("currency"));
  } catch {
    fiatCodes = new Set();
  }
  FALLBACK_FIAT.forEach((c) => fiatCodes.add(c));
  return fiatCodes;
};

export const isCryptoCurrency = (code) => {
  if (!code) return false;
  return !getFiatCodes().has(String(code).toUpperCase());
};

export const decimalsFor = (code) => (isCryptoCurrency(code) ? 8 : 2);

// currency is the code the amount is denominated in; leave it out for USD
// figures and other fixed-2 values.
export const formatCurrencyAmount = (value, currency) => {
  const num = Number(value);
  const digits = decimalsFor(currency);
  if (value === null || value === undefined || Number.isNaN(num)) return (0).toFixed(digits);
  return num.toLocaleString(undefined, { minimumFractionDigits: digits, maximumFractionDigits: digits });
};
